module.exports = __webpack_public_path__ + "assets/img/l2.fb46b585.png";